import { useEffect } from 'react';
import { findVisibleTourAnchor } from './geometry';

export const PRODUCT_TOUR_GLOW_CLASS = 'terra-product-tour-glow';
export const PRODUCT_TOUR_GLOW_RING_CLASS = 'terra-product-tour-glow-ring';

export const productTourGlowStyles = ({
  glowClass = PRODUCT_TOUR_GLOW_CLASS,
  ringClass = PRODUCT_TOUR_GLOW_RING_CLASS,
}: {
  glowClass?: string;
  ringClass?: string;
} = {}): string => `
@keyframes terra-product-tour-ring-pulse {
  0%, 100% {
    box-shadow:
      0 0 0 2px rgba(230, 92, 50, 0.95),
      0 0 14px 4px rgba(230, 92, 50, 0.55),
      0 0 28px 8px rgba(255, 138, 101, 0.25);
  }
  50% {
    box-shadow:
      0 0 0 3px rgba(255, 138, 101, 1),
      0 0 22px 8px rgba(230, 92, 50, 0.75),
      0 0 40px 14px rgba(255, 138, 101, 0.35);
  }
}

.${ringClass} {
  position: fixed;
  pointer-events: none;
  border-radius: 10px;
  animation: terra-product-tour-ring-pulse 1.1s ease-in-out infinite;
}

@keyframes terra-product-tour-glow-pulse {
  0%, 100% {
    box-shadow:
      inset 0 0 0 2px rgba(230, 92, 50, 0.95),
      inset 0 0 12px 2px rgba(230, 92, 50, 0.35),
      0 0 0 2px rgba(230, 92, 50, 0.95),
      0 0 14px 4px rgba(230, 92, 50, 0.55),
      0 0 28px 8px rgba(255, 138, 101, 0.25);
    filter: brightness(1.15);
  }
  50% {
    box-shadow:
      inset 0 0 0 2px rgba(255, 138, 101, 1),
      inset 0 0 16px 3px rgba(230, 92, 50, 0.5),
      0 0 0 3px rgba(255, 138, 101, 1),
      0 0 22px 8px rgba(230, 92, 50, 0.75),
      0 0 40px 14px rgba(255, 138, 101, 0.35);
    filter: brightness(1.35);
  }
}

.${glowClass} {
  border-radius: 10px !important;
  animation: terra-product-tour-glow-pulse 1.1s ease-in-out infinite !important;
  position: relative;
  z-index: 1410 !important;
}
`;

export function useTourAnchorGlow({
  isActive,
  anchorId,
  glowClass = PRODUCT_TOUR_GLOW_CLASS,
}: {
  isActive: boolean;
  anchorId: string | null | undefined;
  glowClass?: string;
}) {
  useEffect(() => {
    if (!isActive || !anchorId || typeof document === 'undefined') {
      return undefined;
    }

    let current: Element | null = null;

    const apply = () => {
      const next = findVisibleTourAnchor(anchorId);
      if (current === next) {
        return;
      }
      current?.classList.remove(glowClass);
      current = next;
      current?.classList.add(glowClass);
    };

    apply();
    const interval = setInterval(apply, 250);

    return () => {
      clearInterval(interval);
      current?.classList.remove(glowClass);
    };
  }, [anchorId, glowClass, isActive]);
}
